import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { WorkstepBase } from 'src/app/_interfaces/workstep';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { PopoverPage } from '../../popover/popover.page';

@Component({
  selector: 'cu-details',
  templateUrl: './cu-details.component.html',
  styleUrls: ['./cu-details.component.scss'],
})
export class CuDetailsComponent {

  constructor(
    public ticketSrv: TicketCustomer.TicketService,
    private feedback: FeedbackService,
    public ticketEditSrv: TicketEditService
  ) { }
  

  public async openWorkSteps(ev: Event){
    await this.feedback.openPopover<EditArt>(PopoverPage,ev,{type: "Worksteps", activeWorkstep: 1},async(result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.ticketSrv.activeWorkstep = this.ticketSrv.worksteps.find(w => w.id == result.data.id)
      await this.ticketSrv.setNewWorkstepAttributes(this.ticketSrv.activeWorkstep.id)
    })
  }

}
